export function filterHandoversByStore(rows, storeId) {
  if (!Array.isArray(rows) || !storeId) return [];
  return rows.filter(note => note?.store_id === storeId);
}
